import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionProductionSkip } from "../../info/production/actionProductionInfo";
import { actionModalCloseAll } from "../../modals/actionModal";
import { TypeActionQuickSkip } from "../actionQuickSkip";
export var epicQuickSkipProductionSkip = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionQuickSkip.SkipProduction), switchMap(function (action) {
        return from([actionModalCloseAll(), actionProductionSkip(action.building)]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-skip-dialog/epics/epicQuickSkipProductionSkip.ts
// module id = 2115
// module chunks = 3